import { Table } from '@chakra-ui/react';
import styled, { css } from 'styled-components';

interface ContainerProps {
  type: 'primary' | 'secondary' | 'childtable' | 'custom';
}

export const Container = styled(Table)<ContainerProps>`
  ${props =>
    props.type === 'primary' &&
    css`
      th {
        font-weight: 500;
        font-size: 12px;
      }

      th:first-child {
        padding-left: 0;
      }

      tr td:first-child {
        padding-left: 0;
      }

      th:last-child {
        padding-right: 0;
        text-align: right;
      }

      tr td:last-child {
        text-align: right;
      }

      th {
        border-bottom-color: #e5e5e6;
      }

      td {
        font-size: 12px;
        border-bottom-color: #e5e5e6;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    `}

  ${props =>
    props.type === 'secondary' &&
    css`
      border-spacing: 0;
      border-collapse: separate;
      border: solid #e5e5e6 1px;
      border-radius: 6px;

      th {
        font-weight: 500;
        color: #53565a;
        font-size: 13px;
        text-transform: capitalize;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-bottom-color: #e5e5e6;
      }

      td {
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;

        button,
        a {
          font-size: 13px;
        }
      }

      tbody td {
        color: #78797a;
      }

      thead {
        background: #fafafa;
      }
    `}

    ${props =>
    props.type === 'childtable' &&
    css`
      border-spacing: 0;
      border-collapse: separate;
      border: none;
      border-radius: 0px;

      th {
        font-weight: 500;
        color: #53565a;
        font-size: 13px;
        text-transform: capitalize;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-bottom-color: #e5e5e6;
      }

      td {
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;

        button,
        a {
          font-size: 13px;
        }
      }

      tbody td {
        color: #78797a;
      }

      thead {
        background: #fafafa;
      }
    `}

  ${props =>
    props.type === 'custom' &&
    css`
      border-spacing: 0;
      border-collapse: separate;
      border: solid #e5e5e6 1px;
      border-radius: 6px;

      th {
        font-weight: 500;
        color: #53565a;
        font-size: 13px;
        text-transform: capitalize;
        padding-top: 1rem;
        padding-bottom: 1rem;
        border-bottom-color: #e5e5e6;
      }

      td {
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 13px;
        border-bottom-color: #e5e5e6;

        button,
        a {
          font-size: 13px;
        }
      }

      tbody td {
        color: #78797a;
      }

      thead {
        background: #fafafa;
      }
    `}
`;
